import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { authorSchema } from '@/core/components';

export const doctoralCommitteeSchema = z.object({
  type: z.enum(['GUIDANCE', 'DEFENDING', 'ABILITATION_SUPPORT']),
  startYear: z.number().nullable(),
  endYear: z.number().nullable(),
  year: z.number().nullable(),
  candidateName: z.string(),
  doctoralSchoolName: z.string(),
  coordinatorName: z.string(),
  authors: z.array(authorSchema).min(1),
});

export const defaultDoctoralCommitteeValues: DefaultValues<DoctoralCommitteeSchema> = {
  type: 'GUIDANCE',
  startYear: null,
  endYear: null,
  year: 0,
  candidateName: '',
  doctoralSchoolName: '',
  coordinatorName: '',
  authors: [],
};

export type DoctoralCommitteeSchema = z.infer<typeof doctoralCommitteeSchema>;
